import { ReactNode } from 'react';
import styles from './PageHeader.module.scss';

type PageHeaderProps = {
  content: string;
  className?: string;
  children?: ReactNode;
};

const PageHeader: React.FC<PageHeaderProps> = ({
  content,
  className,
  children,
}) => {
  return (
    <div className={`${styles.pageHeader} ${className}`}>
      <h2 className={styles.pageHeader__content}>{content}</h2>

      <div className={styles.pageHeader__controls}>{children}</div>
    </div>
  );
};

export default PageHeader;
